import React from 'react'
import { Link } from 'react-router-dom'
/* REDUX */
import { connect } from 'react-redux'

const items = [
	{
		id: 1,
		label: "Relevance",
		svg: <svg viewBox="0 0 512 512"><path d="M101.1 505L7 410.9c-9.4-9.4-9.4-24.6 0-33.9L377 7c9.4-9.4 24.6-9.4 33.9 0l94.1 94.1c9.4 9.4 9.4 24.6 0 33.9L135 505c-9.3 9.3-24.5 9.3-33.9 0zM304 159.2l48.8 48.8 89.9-89.9-48.8-48.8-89.9 89.9zM138.9 39.3l-11.7 23.8-26.2 3.8c-4.7.7-6.6 6.5-3.2 9.8l19 18.5-4.5 26.1c-.8 4.7 4.1 8.3 8.3 6.1L144 115l23.4 12.3c4.2 2.2 9.1-1.4 8.3-6.1l-4.5-26.1 19-18.5c3.4-3.3 1.5-9.1-3.2-9.8L160.8 63l-11.7-23.8c-2-4.1-8.1-4.1-10.2.1zm97.7-20.7l-7.8 15.8-17.5 2.6c-3.1.5-4.4 4.3-2.1 6.5l12.6 12.3-3 17.4c-.5 3.1 2.8 5.5 5.6 4L240 69l15.6 8.2c2.8 1.5 6.1-.9 5.6-4l-3-17.4 12.6-12.3c2.3-2.2 1-6.1-2.1-6.5l-17.5-2.5-7.8-15.8c-1.4-3-5.4-3-6.8-.1zm-192 0l-7.8 15.8L19.3 37c-3.1.5-4.4 4.3-2.1 6.5l12.6 12.3-3 17.4c-.5 3.1 2.8 5.5 5.6 4L48 69l15.6 8.2c2.8 1.5 6.1-.9 5.6-4l-3-17.4 12.6-12.3c2.3-2.2 1-6.1-2.1-6.5l-17.5-2.5-7.8-15.8c-1.4-3-5.4-3-6.8-.1zm416 223.5l-7.8 15.8-17.5 2.5c-3.1.5-4.4 4.3-2.1 6.5l12.6 12.3-3 17.4c-.5 3.1 2.8 5.5 5.6 4l15.6-8.2 15.6 8.2c2.8 1.5 6.1-.9 5.6-4l-3-17.4 12.6-12.3c2.3-2.2 1-6.1-2.1-6.5l-17.5-2.5-7.8-15.8c-1.4-2.8-5.4-2.8-6.8 0z"></path></svg>
	},
	{
		id: 2,
		label: "Popular",
		svg: <svg viewBox="0 0 384 512"><path d="M216 23.858c0-23.802-30.653-32.765-44.149-13.038C48 191.851 224 200 224 288c0 35.629-29.114 64.458-64.85 63.994C123.98 351.538 96 322.22 96 287.046v-85.51c0-21.703-26.471-32.225-41.432-16.504C27.801 213.158 0 261.332 0 320c0 105.869 86.131 192 192 192s192-86.131 192-192c0-170.29-168-193.003-168-296.142z"></path></svg>
	},
	{
		id: 3,
		label: "Newest",
		svg: <svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path></svg>
	}
]

class SideItem extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			active: false
		}
	}

	componentWillReceiveProps(nextProps) {
		const { active } = nextProps
		if (active) {
			this.setState({
				active: true
			})
		} else {
			this.setState({
				active: false
			})
		}
	}

	componentDidMount() {
		const { active } = this.props
		if (active) {
			this.setState({
				active: true
			})
		}
	}

	render() {

		const { item, query } = this.props
		const { id, label, href, svg } = item
		const { active } = this.state

		return (
			<li>
				<Link to={ '/search?q=' + query + '&t=' + label.toLowerCase() }>
					{ active ? (
						<div className="nav-tab active">
							<span className="icon">{ svg }</span>
							<span className="label">{ label }</span>
						</div>
					) : (
						<div className="nav-tab">
							<span className="icon">{ svg }</span>
							<span className="label">{ label }</span>
						</div>
					)}
				</Link>
			</li>
		)
	}
}

class Sbar extends React.Component {

	render() {

		const { filter, pathname, query } = this.props

		const sideitems = items.map((item, index) => {
			if (filter) {
				if (item.label.toLowerCase() === filter.toLowerCase()) {
					return (
						<SideItem
							key={ item.id }
							item={ item }
							active={ true }
							query={ query }
							filter={ filter }
						/>
					)
				}
				return (
					<SideItem
						key={ item.id }
						item={ item }
						active={ false }
						query={ query }
						filter={ filter }
					/>
				)
			} else {
				if (index === 0) {
					return (
						<SideItem
							key={ item.id }
							item={ item }
							active={ true }
							query={ query }
							filter={ filter }
						/>
					)
				}
				return (
					<SideItem
						key={ item.id }
						item={ item }
						active={ false }
						query={ query }
						filter={ filter }
					/>
				)
			}
		})

		return (
			<div className="sidebar">
				<h3 className="subheading">Sort By</h3>
				<ul>
					{ sideitems }
				</ul>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const query = ownProps.query
	const filter = ownProps.filter
	return {
		query,
		filter
	}
}

export default connect(mapStateToProps)(Sbar)



// WEBPACK FOOTER //
// ./src/components/Search/Sbar.js